import { GooglePayAction, GooglePayActionType } from '../actions/googlePay';
import { GooglePayNamespace, GooglePayScriptStatus } from '../state/googlePay';

export const googlePayReducer = (
    state: GooglePayNamespace = {
        canMakePaymentsWithGooglePay: null,
        googlePayPaymentRequest: null,
        googlePayInstance: null,
        googlePayScriptStatus: GooglePayScriptStatus.init,
        hasError: false,
        isLoadingGooglePay: false,
    },
    action: GooglePayAction,
): GooglePayNamespace => {
    switch (action.type) {
        case GooglePayActionType.setCanMakePaymentsWithGooglePay:
        case GooglePayActionType.setGooglePayInstance:
        case GooglePayActionType.setGooglePayPaymentRequest:
        case GooglePayActionType.setGooglePayScriptStatus:
        case GooglePayActionType.setHasErrorInGooglePay:
        case GooglePayActionType.setIsLoadingGooglePay:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
